export function addSupportForDisabledLinks(): void {
  document.body.addEventListener('click', function (e) {
    if (
      e.target instanceof HTMLAnchorElement &&
      e.target.hasAttribute('disabled')
    ) {
      e.preventDefault();
    }
  });
}
